import { TypeOfIncome } from 'projects/borrower-app/src/app/models/enums/type-of-income.enum';

/**
 * Employment (URLA §1b–1d, including military entitlements) and rental (URLA §3) income. Everything else the
 * borrower enters through the simple income dialog is URLA §1e "Income from
 * Other Sources", which must carry the ECOA notice (LLS-886 §7).
 */
const EMPLOYMENT_OR_RENTAL: ReadonlySet<string> = new Set<string>([
  TypeOfIncome.Base,
  TypeOfIncome.Bonus,
  TypeOfIncome.Commissions,
  TypeOfIncome.Overtime,
  TypeOfIncome.ContractBasis,
  TypeOfIncome.MilitaryBasePay,
  TypeOfIncome.MilitaryRationsAllowance,
  TypeOfIncome.MilitaryFlightPay,
  TypeOfIncome.MilitaryHazardPay,
  TypeOfIncome.MilitaryClothesAllowance,
  TypeOfIncome.MilitaryQuartersAllowance,
  TypeOfIncome.MilitaryPropPay,
  TypeOfIncome.MilitaryOverseasPay,
  TypeOfIncome.MilitaryCombatPay,
  TypeOfIncome.MilitaryVariableHousingAllowance,
  TypeOfIncome.SelfEmploymentIncome,
  TypeOfIncome.NetRentalIncome,
]);

export function isUrlaOtherIncomeSource(typeOfIncome: string | null | undefined): boolean {
  return !typeOfIncome || !EMPLOYMENT_OR_RENTAL.has(typeOfIncome);
}
